export default "__VITE_ASSET__60f37475__"